import React, {Component} from 'react';

//libraries
import { CSSTransition } from 'react-transition-group';


//scss
import layerLayoutStyles from '../../static/css/pageStyleModules/layerLayoutStyles.module.scss';
import modalStyles from '../../static/css/componentStyleModules/modalBase.module.scss';

//API
import ThanksControllerAPI from '../../controllers/API/ThanksControllerAPI.js';

import ThanksCardListComponent from '../components/ThanksCardListComponent';
import ThanksSortInputComponent from '../components/inputComponent/ThanksSortInputComponent';
import ThanksInfoSheetComponent from '../components/ThanksInfoSheetComponent';
import ThanksEditAndAdd from './ThanksEditAndAdd';
import SvgIconBaseComponent from '../svgIconComponents/SvgIconBaseComponent';
import ThanksCardMaker from '../components/ThanksCardMaker';
import DialogComponent from '../components/DialogComponent';
import ArticleBase from '../components/articles/ArticleBase';



export default class ThanksDisplay extends Component {

    constructor(props){
        super(props);
        this.state = {
            isLoaded:false,

            isBrowser:true,

            thanksList:[],

            currentThankData:{
                Thanks:{},
                Members:{}
            },

            thankIdToEdit:undefined,

            //sort
            isSortModalShown:false,
            yearSortValue:0,
            monthSortValue:0,
            memberSortId:0,
            memberSortName:'みんな',
            thanksCheckSortValue:'all',
            sortStateString:'すべての期間',

            //editAndAdd
            isEditAddMode:false,

            isThanksCardWindowShown:false,

            //delDialog
            isDeleteDialogShown:false,

            //a2hs
            isA2hsHelpShown:false,

            //manupilateLayer
            manipulateLayerState:'loading',

            //swipe用位置情報
            touchStartY:0,
            touchEndY:0,


        }

        this.manipulateLayerRef = React.createRef();
        this.manipulateMainRef = React.createRef();
    }

    componentWillMount = () => {        
        this.getList().then((result) => {
            process.nextTick(() => {
                this.setState({manipulateLayerState:'max'});            
            })
        });

        if(window.matchMedia('(display-mode: standalone)').matches){
            // ここにPWA環境下でのみ実行するコードを記述
            this.setState({isBrowser:false});
        }
    }

    componentDidMount = () => {
        process.nextTick(() => {
          this.manipulateLayerRef.current.addEventListener('touchstart',this.manipulateLayerTouchStart,{
              once:false,
              passive:true,
              capture:false,
          });
        })
        
    }

    componentWillUnmount = () => {
        this.manipulateLayerRef.current.addEventListener('touchstart',this.manipulateLayerTouchStart);
    }

    getList = () => {
        return new Promise((resolve,reject) => {
            ThanksControllerAPI.index()
            .then((result) => {
                this.initSortInfo();
                this.setState({
                    thanksList:result.data,
                });
                
                this.getSortStateString();

                
                resolve(result.data[0]);
            }).catch((error) => {
                console.log(error.message);
                // this.setState({
                //     displayMode:'hasFailedToGet',
                // })
                reject();
            })
        })
    }

    changeCurrentThank = (targetData) => {
        this.setState({currentThankData:targetData})
    }

    addWindowShow = (event) => {
        event.stopPropagation();        
        this.setState({thankIdToEdit:undefined})
        this.setState({isEditAddMode:true});
    }

    editWindowShow = (event) => {
        event.stopPropagation()
        this.setState({thankIdToEdit:this.state.currentThankData.Thanks.id});
        this.setState({isEditAddMode:true});
    }

    sortWindowShow = (event) => {        
        event.stopPropagation();
        this.setState({isSortModalShown:true});
    }

    //list用
    thanksListCheckToggle = (newData,index) => {
        let dataToRewrite = this.state.thanksList;
        dataToRewrite[index].Thanks = newData;
        this.setState({thankList:dataToRewrite})
    }

    thankDataChange = (targetData) => {
        this.setState({currentThankData:targetData})
        this.manipulateLayerModeChange('minimum');
    }

    //info
    thanksInfoCheckToggle = (newData) => {
        let dataToRewrite = this.state.currentThankData;
        dataToRewrite.Thanks = newData;
        this.setState({currentThankData:dataToRewrite});        
    }

    //del
    deleteThanks = () => {
        //リストの取り直し、infoの表示、currentThanksをクリア
        ThanksControllerAPI.delete(this.state.currentThankData.Thanks.id)
        .then((result) => {
            this.props.onInfoDisplayCall('heartBreak','#999999','忘れました');
            this.deleteDone();
            this.toggleDeleteDialog()
        })
        .catch((error) => {
            this.toggleDeleteDialog()
        })

    }

    toggleDeleteDialog = () => {
        this.setState({isDeleteDialogShown:!(this.state.isDeleteDialogShown)})
    }


    //sort
    initSortInfo = () => {
        this.setState({
            isSortModalShown:false,
            yearSortValue:0,
            monthSortValue:0,
            memberSortId:0,
            thanksCheckSortValue:'all',
        })
    }

    yearValueChange = (yearValue) => {
        this.setState({yearSortValue:yearValue});                
    }

    monthValueChange = (monthValue) => {
        this.setState({monthSortValue:monthValue});                
    }

    memberSortIdChange = (memberId,memberName) => {
        this.setState({
            memberSortId:memberId,
            memberSortName:memberName
        });        
    }

    thanksCheckSortValueChange = (value) => {
        this.setState({thanksCheckSortValue:value})
    }

    sortGo = () => {
        this.setState({isSortModalShown:false});
        ThanksControllerAPI.index({sortObj:{
            year:this.state.yearSortValue,
            month:this.state.monthSortValue,
            memberId:this.state.memberSortId,
            thanksCheck:this.state.thanksCheckSortValue
        }})
        .then((result) => {
            this.setState({
                thanksList:result.data,
            });

            this.getSortStateString();

            this.manipulateLayerModeChange('max');
        }).catch((error) => {
            console.log(error.message);
            // this.setState({
            //     displayMode:'hasFailedToGet',
            // })
        })
    }

    sortBgClicked = (event) => {
        if(event.target === event.currentTarget) {
            this.sortCancel();
        }
    }

    sortCancel = () => {
        this.setState({isSortModalShown:false});
    }

    getSortStateString = () => {
        let stringLineOne = '';

        if(this.state.yearSortValue !== 0 || this.state.monthSortValue !== 0){
            //年、月どちらかに指定がある場合は表記する
            if(this.state.yearSortValue === 0){
                stringLineOne += 'すべての'
            }else{
                stringLineOne += this.state.yearSortValue.toString();
            }

            stringLineOne += '年 ';

            if(this.state.monthSortValue === 0){
                stringLineOne += 'すべての'
            }else{
                stringLineOne += this.state.monthSortValue.toString();
            }

            stringLineOne += '月';
        }else {
            stringLineOne += 'すべての期間';
        }

        
        if(this.state.thanksCheckSortValue === 'checked'){
            stringLineOne += '：チェックあり';
        }else if(this.state.thanksCheckSortValue === 'unchecked'){
            stringLineOne += '：チェックなし';
        }

        this.setState({
            sortStateString:(stringLineOne !== '' ? stringLineOne : 'すべての期間'),
        });
        
    }

    //editAndAdd
    editAndAddDone = (targetId) => {        
        this.setState({manipulateLayerState:'minimum'});
        this.getList().then((result) => {            
            //リストからidを探して
            const thankData = this.state.thanksList.find(data => 
                data.Thanks.id === targetId
            );            
            this.setState({currentThankData:thankData});
        });
    }

    deleteDone = () => {
        this.setState({manipulateLayerState:'max'});
        this.setState({
          currentThankData:{Thanks:{},Members:{}}
        });
        this.getList().then(() => {
        });
    }

    //a2hs
    a2hsHelpOpen = () => {
        this.setState({isA2hsHelpShown:true})
    }


    //manipulateLayer
    manipulateLayerModeChange = (state) => {
        if(this.state.manipulateLayerState !== state){
            this.setState({manipulateLayerState:state});
        }
    }

    manipulateLayerTouchStart = (event) => {
        //情報を初期化
        this.setState({
            touchStartY:0,
            touchEndY:null
        })

        //このタッチイベントは問題を孕んでいる。
        //iOSの仕様だと思うけど、crollが固まった状態（上現、下限）でtouchstartイベントが発動すると、
        //なぜか、わずかな時間スクロールを無視するという仕様がある。
        //致命的ではないが、イラっとくる仕様ではある。
        //これがどういった条件で起こるのか、調べる必要がある。


        if(this.state.manipulateLayerState === 'max' && this.manipulateMainRef.current.scrollTop === 0){
            //maxかつ、scrollTop === 0 のとき
            //現在の位置を記録して、touchmoveEventを設置
            this.setState({touchStartY:event.touches[0].pageY});
            event.currentTarget.addEventListener('touchmove', this.manipulateLayerTouchMove,{
                once:false,
                passive:true,
                capture:false,
            });
            event.currentTarget.addEventListener('touchend', this.manipulateLayerTouchEnd,{
                once:true,
                passive:true,
                capture:false,
            });
        }else if(this.state.manipulateLayerState === 'middium'){
            //現在の位置を記録して、touchmoveEventを設置
            this.setState({touchStartY:event.touches[0].pageY});
            event.currentTarget.addEventListener('touchmove', this.manipulateLayerTouchMove,{
                once:false,
                passive:true,
                capture:false,
            });
            event.currentTarget.addEventListener('touchend', this.manipulateLayerTouchEnd,{
                once:true,
                passive:true,
                capture:false,
            });
        }

    }

    manipulateLayerTouchMove = (event) => {

        //タッチの位置を記録
        this.setState({touchEndY:event.changedTouches[0].pageY});

        //動いた量を取得
        const movingDeg = -1 * (event.changedTouches[0].pageY - this.state.touchStartY);
        this.manipulateLayerRef.current.style.transition = 'none';

        if(this.state.manipulateLayerState === 'max' && movingDeg < 0){

            this.manipulateLayerRef.current.style.bottom = movingDeg + 'px';        
        }else if(this.state.manipulateLayerState === 'middium'){

            //ミディアム状態のheightを入力。この値はcssで決まったものなので、ここを変えるならcssも変えること。
            const middiumHeight = 320;
            const layerHeight = this.manipulateLayerRef.current.clientHeight;

            const baseBottom = -1 * (layerHeight - middiumHeight);

            if(baseBottom + movingDeg < 0){
                this.manipulateLayerRef.current.style.bottom = baseBottom + movingDeg + 'px';        
            }
        }else{
        }
    }

    manipulateLayerTouchEnd = (event) => {

        this.manipulateLayerRef.current.removeAttribute('style');

        if(this.state.touchEndY === null){
            //moveがなかった場合は後始末をしてアウト
            event.currentTarget.removeEventListener('touchmove',this.manipulateLayerTouchMove);
            return;
        }

        //touchStartとtouchEndの差をとる
        const scrollDeg = (this.state.touchEndY - this.state.touchStartY);

        if(scrollDeg > 32){
            if(this.state.manipulateLayerState === 'max'){
                this.manipulateLayerModeChange('middium');
            }
        }else if(scrollDeg < -32){
            if(this.state.manipulateLayerState === 'middium'){

                this.manipulateLayerModeChange('max');
            }
        }

        //後始末
        event.currentTarget.removeEventListener('touchmove',this.manipulateLayerTouchMove);

    }

    render() {

        const themeColorBg = (themeColor) => {

            if(themeColor === null || themeColor === undefined) {
                themeColor = 'hsl(6,77%,62%)';
            }

            const splitArray = themeColor.split(',');
            let hue = splitArray[0].replace('hsl(','');
            let saturation = splitArray[1].replace('%','');
            let lightness = splitArray[2].replace('%)','');

            saturation = parseInt(saturation) - 30;
            lightness = 92;
            const newHslColor = 'hsl(' + hue + ',' + saturation + '%,' + lightness + '%)';
            return newHslColor;

        } 


        const manipulateInner =
            <ThanksCardListComponent 
            thanksList={this.state.thanksList}
            onCardClick={(data) => this.thankDataChange(data)}
            onRewriteBackData={this.thanksListCheckToggle}
            />;

        const layoutWholeClass = () => {
            let classStr = layerLayoutStyles['layoutWholeArea'];
            if(this.state.manipulateLayerState === 'max'){

                return classStr + ' ' + layerLayoutStyles['manipulateLayerFull'];

            }else if(this.state.manipulateLayerState === 'middium'){

                return classStr + ' ' + layerLayoutStyles['manipulateLayerMiddium'];

            }else if(this.state.manipulateLayerState === 'minimum'){

                return classStr + ' ' + layerLayoutStyles['manipulateLayerMinimum'];
            }else if(this.state.manipulateLayerState === 'loading'){

                return classStr + ' ' + layerLayoutStyles['manipulateLayerLoading'];
            }
        }

        const manipuleteButton = (position,icon,clickEvent) => {
            return (
                <CSSTransition
                in={this.state.manipulateLayerState !== 'minimum'}
                timeout={200}
                classNames="simpleFade200"
                unmountOnExit
                mountOnEnter
                >
                  <div className={layerLayoutStyles['manipulateButton'] + ' ' + layerLayoutStyles[position] + ' touchActivePush'}
                  onClick={clickEvent}
                  >
                    <div className={layerLayoutStyles['icon']}>
                      <SvgIconBaseComponent image={icon} fillColor={'#ffffff'}/>
                    </div>
                  </div>
                </CSSTransition>
            )
        }

        return (
            <div className={layoutWholeClass()}>

              <div className={layerLayoutStyles['layoutMainArea']}>
                <div className={layerLayoutStyles['baseLayer']}
                style={{backgroundColor:themeColorBg(this.state.currentThankData.Members.color)}}
                >

                  {this.state.thanksList.map((thankData) => {
                      return (
                          <CSSTransition
                          in={thankData.Thanks.id === this.state.currentThankData.Thanks.id}
                          timeout={200}
                          classNames="simpleFade200"
                          unmountOnExit
                          mountOnEnter
                          key={thankData.Thanks.id}
                          >
                            <div className={layerLayoutStyles['absoluteElement']}>
                              <ThanksInfoSheetComponent 
                              thankData={thankData}
                              onSheetClick={() => this.manipulateLayerModeChange('minimum')}
                              onThanksButtonClick={(data) => this.thanksInfoCheckToggle(data)}
                              onEditButtonClick={this.editWindowShow}
                              onCardMakeButtonClick={() => this.setState({isThanksCardWindowShown:true})}
                              onDelButtonClick={this.toggleDeleteDialog}
                              />
                            </div>
                          </CSSTransition>
                      )
                  })}                  
                </div>

                <div className={layerLayoutStyles['manipulateLayer']}
                ref={this.manipulateLayerRef}
                >

                  <div className={layerLayoutStyles['manipulateLayerHeader']}
                  onClick={() => {
                      if(this.state.manipulateLayerState === 'minimum'){
                          this.manipulateLayerModeChange('max');
                      }
                  }}
                  >
                    {this.state.manipulateLayerState === 'minimum' 
                    ? <div style={{width:'24px',height:'24px'}}>
                        <SvgIconBaseComponent image={'arrowUp'} fillColor={'#999999'} />
                      </div>
                    : <div>
                        <h2>{this.state.sortStateString}</h2>
                        <h3>{this.state.memberSortName}</h3>
                      </div>}
                  </div>

                  <div className={layerLayoutStyles['manipulateMain']}
                  ref={this.manipulateMainRef}
                  // onTouchStart={this.manipulateLayerTouchStart}
                  >

                    {this.state.isBrowser &&
                        <div className={layerLayoutStyles['a2hsAnnotation']}
                        style={{marginBottom:'8px'}}>
                          <div className={layerLayoutStyles['iconArea']}>
                            <SvgIconBaseComponent image="info" fillColor="hsl(6,77%,62%)" />
                          </div>
                          <p>ホーム画面に追加して<br/>スマホアプリとして使ってみよう</p>
                          <div className={layerLayoutStyles['a2hsAnnotationHelp'] + ' touchActiveDark'}
                          onClick={this.a2hsHelpOpen}
                          >追加のしかたをチェック！</div>
                        </div>
                    }

                    {manipulateInner}
                  </div>

                </div>

                {manipuleteButton('left','search',this.sortWindowShow)}
                {manipuleteButton('right','add',this.addWindowShow)}

              </div>

              <CSSTransition
              in={this.state.isSortModalShown}
              timeout={200}
              classNames="simpleFade200"
              unmountOnExit
              mountOnEnter
              >
                <div className={modalStyles['selectModalBase']}
                onClick={this.sortBgClicked}>
                  <div className={modalStyles['modal']}>
                    <ThanksSortInputComponent
                    yearSortValue={this.state.yearSortValue}
                    onYearValueChange={(year) => this.yearValueChange(year)}
                    monthSortValue={this.state.monthSortValue}
                    onMonthValueChange={(month) => this.monthValueChange(month)}
                    memberSortId={this.state.memberSortId}
                    onMemberIdChange={(memberId,memberName) => this.memberSortIdChange(memberId,memberName)}
                    thanksCheckSortValue={this.state.thanksCheckSortValue}
                    onThanksCheckValueChange={(value) => this.thanksCheckSortValueChange(value)}
                    onOkButtonClick={this.sortGo} 
                    onCancelButtonClick={this.sortCancel}
                    />
                  </div>
                </div>
              </CSSTransition>

              <CSSTransition
              in={this.state.isEditAddMode}
              timeout={200}
              classNames="simpleFade200"
              unmountOnExit
              mountOnEnter
              >
                <div className={modalStyles['inputModalBase']}>
                  <div className={modalStyles['modal']}>
                    <ThanksEditAndAdd
                    thankId={this.state.thankIdToEdit}
                    onSubmitDone={this.editAndAddDone}
                    onCancelButtonClick={() => this.setState({isEditAddMode:false})}
                    onDeleteDone={this.deleteDone}
                    onInfoDisplayCall={this.props.onInfoDisplayCall}
                    />
                  </div>
                </div>
              </CSSTransition>

              <CSSTransition
              in={this.state.isThanksCardWindowShown}
              timeout={200}
              classNames="simpleFade200"
              unmountOnExit
              mountOnEnter
              >
                <ThanksCardMaker
                thankData={this.state.currentThankData.Thanks}
                memberData={this.state.currentThankData.Members}
                onCloseButtonClick={() => this.setState({isThanksCardWindowShown:false})}
                />
              </CSSTransition>

              <CSSTransition
              in={this.state.isDeleteDialogShown}
              timeout={200}
              classNames="simpleFade200"
              unmountOnExit
              mountOnEnter
              >
                <DialogComponent 
                  question={'本当に忘れますか？'}
                  answers={[
                      {display:'忘れる',isGhostStyle:false, onButtonClick:this.deleteThanks},
                      {display:'やめる', isGhostStyle:true, onButtonClick:this.toggleDeleteDialog}
                  ]} 
                  />
              </CSSTransition>

              <CSSTransition
              in={this.state.isA2hsHelpShown}
              timeout={200}
              classNames="simpleFade200"
              unmountOnExit
              mountOnEnter
              >
                <ArticleBase 
                articleMode="A2HSHelp" 
                singleHelp={true}
                onBackgroundClick={() => {this.setState({isA2hsHelpShown:false})}}
                />
              </CSSTransition>


            </div>
        )
    }

};